export enum HotspotType {
  RECYCLER = 'RECYCLER',
  SERVICE_CENTER = 'SERVICE_CENTER',
  CUSTOMER = 'CUSTOMER'
}
